module.exports = __webpack_public_path__ + "img/guitar.e81048c1.svg";